import React from "react";
import { ShieldCheck, Zap, Wrench, Leaf } from "lucide-react";
import { whyUs } from "../mock";

const iconMap = { ShieldCheck, Zap, Wrench, Leaf };

const WhyUs = () => {
  return (
    <section id="pourquoi" className="py-20 md:py-28 bg-neutral-950 text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-5">
              Pourquoi nous
            </p>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl leading-tight">
              La rigueur d'un artisan,{" "}
              <span className="text-brand">l'exigence d'un industriel.</span>
            </h2>
            <p className="mt-6 text-neutral-400 leading-relaxed max-w-lg">
              Ptitservices-pro.com accompagne les entreprises et les maîtres
              d'ouvrage depuis plus de 4 ans. Un savoir-faire humain, des
              standards professionnels.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-10">
            {whyUs.map((w) => {
              const Icon = iconMap[w.icon];
              return (
                <div key={w.title} className="border-t border-neutral-800 pt-5">
                  <Icon size={26} className="text-brand mb-4" />
                  <h3 className="font-heading font-bold text-lg">{w.title}</h3>
                  <p className="mt-2 text-neutral-400 text-sm leading-relaxed">
                    {w.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
